<template>
  <div
    class="divParent"
    v-lazy:background-image="{
      src: bgUrl,
      loading: require('./../../../../../assets/wheelplanting.jpg'),
    }"
  >
    <white-title-color-img-widge
      :title="title"
      :desc="desc"
      :bgFont="bgFont"
      class="workAdvice_title"
    >
    </white-title-color-img-widge>
    <div class="divContent">
      <div class="divPeople">
        <img :src="peopleUrl" />
        <div
          class="divPeopleDesc"
          v-lazy:background-image="{
            src: require('./../../../../../assets/wheelplanting.png'),
          }"
        >
          >
          {{ explain }}
        </div>
      </div>
      <div
        class="divDetails"
        v-lazy:background-image="{
          src: bgDetailsUrl,
          loading: require('./../../../../../assets/wheelplanting.jpg'),
        }"
      >
        <div v-for="item in details" :key="item">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import whiteTitleColorImgWidge from "../asserts/common/components/whiteTitleColorImgWidge";
export default {
  components: {
    whiteTitleColorImgWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    bgFont: {
      type: String,
      default: "",
    },
    peopleUrl: {
      type: String,
      default: "",
    },
    explain: {
      type: String,
      default: "",
    },
    details: {
      type: Array,
      default: function() {
        return [];
      },
    },
    bgDetailsUrl: {
      type: String,
      default: "",
    },
    bgUrl: {
      type: String,
      default: "",
    },
    bgCrapezoidal: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../asserts/scss/workAdviceWidge.scss";
</style>
